<template>
    <RegularModal ref="modal">
        <template v-slot:title> {{ translate("notification_center.listing_item.show_content") }}</template>
        <template v-slot:body>
            <div class="columns">
                <div class="column">
                    <p class="mb-3">
                        {{ translate("notification_center.listing_item.content_of_your_notification") }}
                    </p>
                    <div class="content">
                        <pre class="has-word-wrapping">{{ content }}</pre>
                    </div>
                </div>
            </div>
        </template>
        <template v-slot:footer>
            <button class="button" @click="close">{{ translate("common.close") }}</button>
        </template>
    </RegularModal>
</template>

<script>
    import RegularModal from "../../Common/RegularModal";
    import translatorMixin from "../../Common/translatorMixin";

    export default {
        name: "show-content-modal",
        components: { RegularModal },
        mixins: [translatorMixin],
        data() {
            return {
                content: "",
            };
        },
        methods: {
            open(content) {
                this.content = content;
                this.$refs.modal.open();
            },
            close() {
                this.$refs.modal.close();
            },
        },
    };
</script>

<style scoped></style>
